import { Button } from "primereact/button";
import React, { useEffect, useState, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import AddEditVehicleType from "./AddEditExemptedVehicle";
import moment from 'moment';
// import appUrl from "../../../config/appUrl";
import { Image } from "primereact/image";
import appUrl from "../../../config/appUrl";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
const ManageExemptedVehicle = () => {
  const [displayDialog, setDisplayDialog] = useState(false);
  const [addEditVehicleType, setAddEditVehicleType] = useState(false);
  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [exemptedVehicleId, setexemptedVehicleId] = useState("");
  const [roleName, setRoleName] = useState({});
  const loginUser = useSelector((state) => state?.loginUser);
  const { user } = loginUser || {};

const role = user?.role?.role || roleName?.role;
  const editVehicleType = (rowData) => {
    setDisplayDialog(true);
    setAddEditVehicleType(true);
    setexemptedVehicleId(rowData?._id);
  };
  const storageData = () => {
    const storedLoginRes = JSON.parse(localStorage.getItem("user"));
    const userTypeIs = storedLoginRes?.role;
    setRoleName({ role: userTypeIs?.role });
  };

  useEffect(() => {
    storageData();
  }, []);

  const onHide = (name) => {
    setDisplayDialog(false);
  };

  const handleDialog = () => {
    setDisplayDialog(true);
  };


  // const getUserList = async () => {
  //   try {
  //     let response;
  //     if (user?.site !== null) {
  //       response = await fetch(
  //         `${appUrl.BASE_URL}user?role=${formik?.values?.role}&site=${user?.site}`
  //       );
  //     } else {
  //       response = await fetch(
  //         `${appUrl.BASE_URL}user?role=${formik?.values?.role}`
  //       );
  //     }
  //     const data = await response?.json();
  //     setUserList(data);
  //     //setFilteredUserList(data); // Initially, set the filtered list to the entire list
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  // useEffect(() => {
  //   storageData();
  // }, []);


  // User role base data
  // If Admin show all and add button
  // if site admin show all but not add button
  // If machine user show exempted only
  const getExemptedVehicles = async () => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}exempted`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      console.log("Server Response:", data);

      if (response.ok) {
        setVehicleTypeList(data.data);
      } else {
        alert(data.msg);
      }
    } catch (error) {
      console.error("Error fetching exempted vehicles:", error);
    }
  };

  useEffect(() => {
    getExemptedVehicles();
  }, []);

  const actionTemp = (rowData) => {
    return (
      <div className="flex">
        <Button
          tooltip="Edit"
          icon="pi pi-user-edit"
          tooltipOptions={{ position: "top" }}
          onClick={() => editVehicleType(rowData)}
          className="p-button-rounded p-button-text"
        />
        <Button
          tooltip="Delete"
          tooltipOptions={{ position: "top" }}
          onClick={() => confirm(rowData)}
          icon="pi pi-trash"
          className="p-button-rounded p-button-text"
        />
      </div>
    );
  };

  const confirm = (rowData) => {
    confirmDialog({
      message: "Do you want to delete this record?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p-button-primary",
      rejectClassName: "p-button-danger",
      accept: () => onDeleteConfirmation(rowData),
      reject,
    });
  };

  const onDeleteConfirmation = async (rowData) => {
    try {
      const response = await fetch(
        `${appUrl.BASE_URL}exempted/${rowData?._id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const data = await response.json();

      if (response.ok) {
        toast.success("Vehicle Deleted successfully");
        await getExemptedVehicles();
      } else {
        console.error(data?.msg); // Error message from the API
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reject = () => { };

  const icon = (rowData) => {
    return (
      <>
        <div className="vehicle-icon">
          <Image
            src={"http://52.230.119.123:3024/" + rowData?.icon}
            alt="Vehicle Image"
            preview
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Dialog
        draggable={false}
        visible={displayDialog}
        style={{ width: "55vw" }}
        onHide={() => onHide("displayDialog")}
      >
        <AddEditVehicleType
          onHide={onHide}
          getExemptedVehicles={getExemptedVehicles}
          addEditVehicleType={addEditVehicleType}
          exemptedVehicleId={exemptedVehicleId}
          vehicleTypeList={vehicleTypeList}
        />
      </Dialog>

      <ConfirmDialog />

      <div>
        <div className="p-fluid grid align-items-center">
          <div className="col-12 md:col-10">
            <div className="flex align-items-center">
              <h5
                className="mt-0 text-2xl mb-0 font-semibold text-[#17171B]"
                style={{ color: "#17171B" }}
              >
                Exempted Vehicle Management
              </h5>
            </div>
          </div>

         {role === "super_admin" && (
            <div className="col-12 md:col-2 text-right">
              <Button
                label="Add New"
                className="Add__New-Button"
                aria-label="Add User"
                onClick={() => {
                  handleDialog();
                  setAddEditVehicleType(false);
                }}
                icon="pi pi-plus"
                iconPos="right"
              />
            </div>
          )}
        </div>
      </div>

      <div className="card custom_card p-datatable-sm">
        <DataTable
          scrollable
          // scrollHeight="382px"
          responsiveLayout="scroll"
          paginator
          rows={10}
          value={vehicleTypeList}
          emptyMessage="No data found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rowsPerPageOptions={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
        >
          <Column
            field="vehicleRegNumber"
            header="Vehicle Reg Number"
            body={(rowData) => rowData.vehicleRegNumber || '-'}
          />
          <Column
            field="qr"
            header="QR Number"
            body={(rowData) => rowData.qr || '-'}
          />
          <Column
            field="createdDate"
            header="Created Date"
            body={(rowData) =>
              rowData.createdDate
                ? moment(rowData.createdDate).format('DD-MM-YYYY hh:mm A')
                : '-'
            }
          />


       {role === 'super_admin' && (
  <Column body={actionTemp} header="Action"></Column>
)}
        </DataTable>
      </div>
    </>
  );
};

export default ManageExemptedVehicle;
